import React from 'react'
import { Contact, LoggedUser } from '../../shared/shared.models'
import { Routes, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IStoreInterface } from '../../configs/store.config'
import { AdminApi } from '../admin.api'
import Loader from 'react-spinners/DotLoader'
import { useAlert } from 'react-alert'
import { Column } from '../../shared/shared.styled'
import styled from 'styled-components'
import { Typography, Colors } from '../../configs/styled.config'
import { ContactDetailsPage } from './contact-details.page'

export interface IBaseInterface {
    contact: Contact
    setContact: (value: Contact) => void
}

interface ContactPageProps {
    contactId: string
}

/**
 * This page handles the routing of the ContactPage
 * @param contactId {string}
 */
export const ContactPage = ({ contactId }: ContactPageProps) => {
    // Hooks
    const alert = useAlert()
    const loggedUser = useSelector(
        (state: IStoreInterface) => state.adminReducer.user as LoggedUser
    )
    const [isLoading, setIsLoading] = React.useState(true)
    const [contact, setContact] = React.useState<Contact>()

    /**
     * Gets the contact
     */
    // Effect to fetch the list of contacts
    React.useEffect(() => {
        setIsLoading(true)
        AdminApi.methods
            .getContact(contactId)
            .finally(() => {
                setIsLoading(false)
            })
            .then(
                (res) => {
                    setContact(res.data.contact)
                },
                (e) => {
                    alert.error('Erro ao buscar a informação deste contato')
                }
            )
    }, [alert, contactId, loggedUser.companyUuid])

    if (isLoading) {
        return (
            <Column
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Loader color={Colors['gold-pmauto']} />
                <LoadingText>A carregar a informação do contato</LoadingText>
            </Column>
        )
    }

    if (!contact) {
        return (
            <Column
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Loader color={Colors['gold-pmauto']} />
                <LoadingText>A carregar a informação do contato</LoadingText>
            </Column>
        )
    }

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <ContactDetailsPage
                        contact={contact}
                        setContact={setContact}
                    />
                }
            />
        </Routes>
    )
}

const LoadingText = styled('span')`
    margin-top: 24px;
    ${Typography['Body_Text_#1_Regular_Center']}
`
